module.exports = __webpack_public_path__ + "img/icon-old.28d55bed.png";